import { Component, Input, OnInit } from '@angular/core';
import { MenuService } from '../app.menu.service';
import { LayoutService } from '../service/app.layout.service';

export type Theme = {
  name: string;
  color: string;
};

@Component({
  selector: 'app-config',
  templateUrl: './app.config.component.html'
})
export class AppConfigComponent implements OnInit {
  @Input() minimal = false;

  componentThemes: any[] = [];

  menuThemes: any[] = [];

  topbarThemes: any[] = [];

  scales: number[] = [14];

  constructor(
    public layoutService: LayoutService,
    public menuService: MenuService
  ) {}

  get visible(): boolean {
    return this.layoutService.state.configSidebarVisible;
  }

  set visible(_val: boolean) {
    this.layoutService.state.configSidebarVisible = _val;
  }

  get scale(): number {
    return this.layoutService.config.scale;
  }

  set scale(_val: number) {
    this.layoutService.config.scale = _val;
  }

  get menuMode(): string {
    return this.layoutService.config.menuMode;
  }

  set menuMode(_val: string) {
    this.layoutService.config.menuMode = _val;
    if (this.layoutService.isSlim() || this.layoutService.isHorizontal()) {
      this.menuService.reset();
    }
  }

  get menuProfilePosition(): string {
    return this.layoutService.config.menuProfilePosition;
  }

  set menuProfilePosition(_val: string) {
    this.layoutService.config.menuProfilePosition = _val;
    if (this.layoutService.isSlim() || this.layoutService.isHorizontal()) {
      this.menuService.reset();
    }
  }

  get colorScheme(): string {
    return this.layoutService.config.colorScheme;
  }

  set colorScheme(_val: string) {
    this.changeColorScheme(_val);
  }

  get inputStyle(): string {
    return this.layoutService.config.inputStyle;
  }

  set inputStyle(_val: string) {
    this.layoutService.config.inputStyle = _val;
  }

  get ripple(): boolean {
    return this.layoutService.config.ripple;
  }

  set ripple(_val: boolean) {
    this.layoutService.config.ripple = _val;
  }

  get menuTheme(): string {
    return this.layoutService.config.menuTheme;
  }

  get topbarTheme(): string {
    return this.layoutService.config.topbarTheme;
  }

  get componentTheme(): string {
    return this.layoutService.config.componentTheme;
  }

  ngOnInit() {
    this.componentThemes = [
      { name: 'indigo', color: '#3F51B5' },
      { name: 'deeppurple', color: '#673AB7' },
      { name: 'teal', color: '#009688' },
      { name: 'bluegrey', color: '#607D8B' }
    ];

    this.menuThemes = [
      { name: 'dark', color: '#434B54' },
      { name: 'bluegrey', color: '#37474F' }
    ];

    this.topbarThemes = [
      { name: 'grey', color: '#616161' },
      { name: 'bluegrey', color: '#546E7A' }
    ];
  }

  onConfigButtonClick() {
    this.layoutService.showConfigSidebar();
  }

  changeColorScheme(colorScheme: string) {
    this.layoutService.onColorSchemeChange(colorScheme);
  }

  changeTheme(theme: string) {
    const themeLink = <HTMLLinkElement>document.getElementById('theme-link');
    const newHref = themeLink
      .getAttribute('href')
      ?.replace(this.layoutService.config.componentTheme, theme);
    this.layoutService.replaceThemeLink(newHref, () => {
      this.layoutService.config.componentTheme = theme;
      this.layoutService.onConfigUpdate();
    });
  }

  changeTopbarTheme(theme: string) {
    this.layoutService.config.topbarTheme = theme;
    this.layoutService.onConfigUpdate();
  }

  changeMenuTheme(theme: string) {
    this.layoutService.config.menuTheme = theme;
    this.layoutService.onConfigUpdate();
  }

  decrementScale() {
    this.scale--;
    this.applyScale();
  }

  incrementScale() {
    this.scale++;
    this.applyScale();
  }

  applyScale() {
    document.documentElement.style.fontSize = this.scale + 'px';
  }
}
